import { useInteractionStyle } from "../../organisms/interaction/style";
import { useMemo, useEffect, useState } from "react";
import {
	NavigationActions,
	TabType,
	useNavigationStore,
} from "@/common/stores/persistingStores/navigation";
import { Flex } from "@/components/atoms/flex";
import { useAllInteractionsStyle } from "./style";
import { AllActiveInteractionsTable } from "@/components/molecules/allActiveInteractionTable";
import { AllWaitingInteractionsTable } from "@/components/molecules/allWaitingInteractionTable";
import { InteractionCard } from "@/components/organisms/interaction";
import { useSupervisor } from "@/hooks/supervisor";
import MessageOutlet from "@/common/messages/outlet";
import { ResizableContainer } from "@/components/atoms/resizableContainer";
import { ContainerSizeDefaults } from "@/common/constants";
import { ResizeHint } from "@/components/atoms/resizeHint";
import { CacheKey } from "@/common/stores/persistingStores/app";
import { useResizeHook } from "@/hooks/resize";
import { useResponsiveBreakpoints } from "@/hooks/responsive";
import { AllInteractionsMobile } from "./AllInteractionsMobile";

export const AllInteractions = () => {
	const interactionStyleClasses = useInteractionStyle();
	const allInteractionsStyleClasses = useAllInteractionsStyle();

	const [currentSupervisorRights, setCurrentSupervisorRights] =
		useState<boolean>(false);

	const setSelectedTab = useNavigationStore(
		(state: NavigationActions) => state.setSelectedTab
	);
	const isAllInteractionsTabVisibile = useSupervisor();

	const { isMobile } = useResponsiveBreakpoints();

	useEffect(() => {
		if (!isAllInteractionsTabVisibile && currentSupervisorRights) {
			setSelectedTab(TabType.Interactions);
		}
		setCurrentSupervisorRights(isAllInteractionsTabVisibile ?? false);
	}, [isAllInteractionsTabVisibile]);

	const [allWaitingInteractionsPanelWidth, onResizeStop] = useResizeHook(
		CacheKey.AllWaitingInteractionsPanelWidth,
		500
	);

	const desktopView = useMemo(
		() => (
			<div className={allInteractionsStyleClasses.container}>
				<ResizableContainer
					minWidth={ContainerSizeDefaults.AllWaitingInteractionsMinWidth}
					maxWidth={ContainerSizeDefaults.AllWaitingInteractionsMaxWidth}
					width={allWaitingInteractionsPanelWidth}
					enabledSides={["right"]}
					handleStyles={{ right: { right: "0px", width: "1.5px" } }}
					handleComponent={{
						right: (
							<ResizeHint
								className={allInteractionsStyleClasses.resizeHintRight}
							/>
						),
					}}
					children={<AllWaitingInteractionsTable />}
					onResizeStop={onResizeStop}
				></ResizableContainer>
				<AllActiveInteractionsTable />
			</div>
		),
		[allWaitingInteractionsPanelWidth]
	);

	const mobileView = useMemo(() => <AllInteractionsMobile />, []);

	return (
		<Flex
			id="all-interactions-container"
			column
			className={interactionStyleClasses.supervisorContainer}
		>
			<MessageOutlet namespace="allInteractions" />
			{isMobile ? mobileView : desktopView}
			{!isMobile && <InteractionCard />}
		</Flex>
	);
};
